(function (window, document) {
  'use strict';

  // Constants
  var MAX_UPLOAD_SIZE = 25 * 1024 * 1024; // 25MB (aligné spec API /uploads)
  var ALLOWED_MIME = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
  var DOC_ZONE_UID = 0;

  // i18n & HTML escaping
  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var h = escapeHtml; // shortcut, used in template literals

  // Shared helpers
  function renderZones(docs) {
    return docs
      .map(function (d) {
        var optionalTag = d.required
          ? ''
          : ` <span class="bp-modal-docs__optional">${h(t('modal_docs_optional_tag'))}</span>`;
        var inputId = 'bp-doc-input-' + ++DOC_ZONE_UID;
        return `<label class="bp-modal-docs__zone" data-bp-doc-zone data-doc-key="${h(d.key)}" for="${h(inputId)}"><input id="${h(inputId)}" class="bp-modal-docs__input--hidden" type="file" data-bp-doc-input accept=".pdf,.jpg,.jpeg,.png,.heic,.heif"><span class="bp-modal-docs__zone-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V4M12 4l-4 4M12 4l4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 14v4a2 2 0 002 2h12a2 2 0 002-2v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="bp-modal-docs__zone-body"><span class="bp-modal-docs__label">${h(t('modal_docs_label_' + d.key))}${optionalTag}</span><span class="bp-modal-docs__hint" data-bp-doc-hint>${h(t('modal_docs_format_hint'))}</span><span class="bp-modal-docs__filename" data-bp-doc-filename hidden></span><span class="bp-modal-docs__error" data-bp-doc-error hidden></span></span></label>`;
      })
      .join('');
  }

  function attachZoneListeners(root, files, onChange) {
    root.querySelectorAll('[data-bp-doc-zone]').forEach(function (zone) {
      var key = zone.getAttribute('data-doc-key');
      var input = zone.querySelector('[data-bp-doc-input]');
      var fnameEl = zone.querySelector('[data-bp-doc-filename]');
      var errEl = zone.querySelector('[data-bp-doc-error]');
      // Restaure l'affichage du filename si le fichier était déjà uploadé
      if (files[key]) {
        fnameEl.textContent = files[key].name;
        fnameEl.hidden = false;
      }
      var reject = function (msgKey) {
        errEl.textContent = t(msgKey);
        errEl.hidden = false;
        files[key] = null;
        fnameEl.hidden = true;
        onChange();
      };
      input.addEventListener('change', function () {
        errEl.hidden = true;
        errEl.textContent = '';
        var f = input.files && input.files[0];
        if (!f) {
          files[key] = null;
          fnameEl.hidden = true;
          onChange();
          return;
        }
        if (f.size > MAX_UPLOAD_SIZE) return reject('upload_error_size');
        if (ALLOWED_MIME.indexOf(f.type) === -1) return reject('upload_error_mime');
        files[key] = f;
        fnameEl.textContent = f.name;
        fnameEl.hidden = false;
        onChange();
      });
    });
  }

  async function uploadAllDocs(dlg, submitBtn, allDocs, files, repriseId, opts) {
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = t('upload_uploading');
    try {
      for (var i = 0; i < allDocs.length; i++) {
        var d = allDocs[i];
        var f = files[d.key];
        if (f) await window.buybackApi.uploadDoc(repriseId, d.key, f);
      }
      renderDocsSuccess(dlg, opts);
    } catch (err) {
      submitBtn.disabled = false;
      submitBtn.setAttribute('aria-busy', 'false');
      submitBtn.textContent = originalLabel;
      var host = dlg.querySelector('.bp-modal-docs__zones') || dlg.querySelector('[data-bp-step-body]');
      var existing = dlg.querySelector('.bp-modal-docs__global-error');
      if (existing) existing.remove();
      var errBox = document.createElement('p');
      errBox.className = 'bp-modal-docs__global-error';
      errBox.textContent = t('error_generic');
      if (host) host.appendChild(errBox);
    }
  }

  // Success screen (shared)
  function renderDocsSuccess(dlg, opts) {
    var container = dlg.querySelector('.bp-modal__container');
    if (!container) {
      if (typeof opts.onAllUploaded === 'function') opts.onAllUploaded();
      window.buybackPortalModals._closeCurrent();
      return;
    }
    var checkSvg =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    container.innerHTML =
      `<button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button>` +
      `<div class="bp-modal-docs__success"><span class="bp-modal-docs__success-check" aria-hidden="true">${checkSvg}</span>` +
      `<h2 class="bp-modal-docs__success-title">${h(t('modal_docs_success_title'))}</h2>` +
      `<p class="bp-modal-docs__success-subtitle">${h(t('modal_docs_success_subtitle'))}</p>` +
      `<button type="button" class="bp-modal-docs__success-close" data-bp-docs-success-close>${h(t('modal_docs_success_close'))}</button></div>`;
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');

    var finish = function () {
      if (typeof opts.onAllUploaded === 'function') opts.onAllUploaded();
      window.buybackPortalModals._closeCurrent();
    };
    window.buybackPortalModals._bindClose(dlg, '[data-bp-modal-close]');
    var closeBtn = container.querySelector('[data-bp-docs-success-close]');
    if (closeBtn) closeBtn.addEventListener('click', finish);
  }

  // PRO flow (monolithic, single dialog)
  function openProDocsModal(opts) {
    var repriseId = opts.repriseId;
    var docs = [
      { key: 'facture', required: true },
      { key: 'rib', required: false },
    ];
    var optionalDocs =
      opts.statusSlug === 'contractualisation' ? [{ key: 'marquage_screenshot', required: false }] : [];
    var allDocs = docs.concat(optionalDocs);
    var files = {};
    var introHtml = `<p class="bp-modal__intro">${h(t('modal_docs_intro_pro'))}</p>`;
    var optionalSectionHtml =
      optionalDocs.length > 0
        ? `<div class="bp-modal-docs__optional-section"><p class="bp-modal-docs__optional-title">${h(t('modal_docs_optional_section_title'))}</p><div class="bp-modal-docs__zones" data-bp-optional-zone-container>${renderZones(optionalDocs)}</div></div>`
        : '';
    var content = `<div class="bp-modal__container bp-modal-docs"><button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button><h2 class="bp-modal__title">${h(t('modal_docs_title'))}</h2>${introHtml}<div class="bp-modal-docs__zones">${renderZones(docs)}</div>${optionalSectionHtml}<div class="bp-modal__actions"><button type="button" class="bp-link-button" data-bp-docs-cancel>${h(t('modal_docs_cancel'))}</button><button type="button" class="bp-cta-pastel" data-bp-docs-submit disabled>${h(t('modal_docs_submit'))}</button></div></div>`;

    return window.buybackPortalModals._createDialog({
      className: 'bp-modal--docs',
      content: content,
      ariaLabel: t('modal_docs_title'),
      onMount: function (dlg) {
        var submitBtn = dlg.querySelector('[data-bp-docs-submit]');
        var updateSubmit = function () {
          var missing = docs.filter(function (d) {
            return d.required && !files[d.key];
          });
          submitBtn.disabled = missing.length > 0;
        };
        attachZoneListeners(dlg, files, updateSubmit);
        window.buybackPortalModals._bindClose(dlg, '[data-bp-modal-close]');
        window.buybackPortalModals._bindClose(dlg, '[data-bp-docs-cancel]');
        submitBtn.addEventListener('click', function () {
          uploadAllDocs(dlg, submitBtn, allDocs, files, repriseId, opts);
        });
      },
    });
  }

  // PART flow (3-step stepper, single dialog)
  function buildStepperHtml() {
    var stepTpl = t('modal_docs_step_aria_label_tpl');
    var dots = '';
    for (var i = 1; i <= 3; i++) {
      var stepLabel =
        stepTpl && stepTpl !== 'modal_docs_step_aria_label_tpl' ? stepTpl.replace('{{ i }}', i) : 'Step ' + i + ' of 3';
      dots +=
        `<span class="bp-modal-docs__step-dot" role="listitem" data-bp-step-dot="${i}" aria-label="${h(stepLabel)}">${i}</span>` +
        (i < 3 ? `<span class="bp-modal-docs__step-bar" data-bp-step-bar="${i}" aria-hidden="true"></span>` : '');
    }
    var stepperLabel = t('modal_docs_stepper_aria_label');
    if (stepperLabel === 'modal_docs_stepper_aria_label') stepperLabel = 'Document upload steps';
    return (
      `<div class="bp-modal-docs__stepper" data-bp-stepper role="list" aria-label="${h(stepperLabel)}">${dots}</div>` +
      `<p class="bp-modal-docs__step-label" data-bp-step-label>${h(t('modal_docs_step1_label'))}</p>`
    );
  }

  function updateStepperUi(dlg, currentStep) {
    for (var i = 1; i <= 3; i++) {
      var dot = dlg.querySelector('[data-bp-step-dot="' + i + '"]');
      if (dot) {
        dot.classList.toggle('is-active', i === currentStep);
        dot.classList.toggle('is-done', i < currentStep);
        if (i === currentStep) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      }
      if (i < 3) {
        var bar = dlg.querySelector('[data-bp-step-bar="' + i + '"]');
        if (bar) bar.classList.toggle('is-done', i < currentStep);
      }
    }
    var label = dlg.querySelector('[data-bp-step-label]');
    if (label) label.textContent = t('modal_docs_step' + currentStep + '_label');
  }

  // Téléchargement authentifié du contrat (mode Bearer). Un <a href target=_blank>
  // ne peut pas porter le header Authorization → sur Safari/iOS (cookie bloqué) il
  // tombait en 401. On récupère donc le PDF en blob via l'API avec le token Bearer.
  function bindContractDownload(root, repriseId) {
    var link = root.querySelector('[data-bp-contract-download]');
    if (!link) return;
    link.addEventListener('click', async function (e) {
      e.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      // Ouvre l'onglet de façon SYNCHRONE (avant tout await) pour préserver le
      // user gesture et ne pas être bloqué par le popup blocker de Safari.
      var win = window.open('', '_blank');
      link.setAttribute('aria-busy', 'true');
      try {
        var res = await window.buybackApi.getContract(repriseId);
        var blob = await res.blob();
        var url = URL.createObjectURL(blob);
        if (win && !win.closed) {
          win.location = url;
        } else {
          var a = document.createElement('a');
          a.href = url;
          a.download = 'contrat.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 60000);
      } catch (err) {
        if (win && !win.closed) win.close();
        var msg = err && err.message;
        var key =
          msg === 'UNAUTHENTICATED' || msg === 'HTTP_401'
            ? 'modal_docs_banner_error_unauthenticated'
            : 'modal_docs_banner_error_unavailable';
        if (window.BuybackPortalToast && window.BuybackPortalToast.info) {
          window.BuybackPortalToast.info(t(key));
        }
      } finally {
        link.removeAttribute('aria-busy');
      }
    });
  }

  function buildStepBody(step, opts) {
    var repriseId = opts.repriseId;
    var apiBaseUrl = String(opts.apiBaseUrl || '').replace(/\/?$/, '/');
    var navPrev = `<button type="button" class="bp-link-button bp-modal-docs__nav-prev" data-bp-step-prev${step === 1 ? ' disabled hidden' : ''}>${h(t('modal_docs_nav_prev'))}</button>`;
    if (step === 1) {
      var contractHref = apiBaseUrl + 'api/client/reprises/' + encodeURIComponent(repriseId) + '/contract';
      var banner = `<div class="bp-modal-docs__banner"><div class="bp-modal-docs__banner-body"><p class="bp-modal-docs__banner-title">${h(t('modal_docs_banner_title'))}</p><p class="bp-modal-docs__banner-subtitle">${h(t('modal_docs_banner_subtitle'))}</p></div><a class="bp-cta-pastel bp-modal-docs__banner-cta" href="${h(contractHref)}" target="_blank" rel="noopener" data-bp-contract-download>${h(t('modal_docs_banner_cta'))}</a></div>`;
      return (
        banner +
        `<div class="bp-modal-docs__nav">${navPrev}<button type="button" class="bp-cta-pastel bp-modal-docs__nav-next" data-bp-step-next>${h(t('modal_docs_nav_next'))}</button></div>`
      );
    }
    if (step === 2) {
      return (
        `<p class="bp-modal__intro">${h(t('modal_docs_step2_intro'))}</p>` +
        `<div class="bp-modal-docs__zones">${renderZones([{ key: 'contrat_signe', required: true }])}</div>` +
        `<div class="bp-modal-docs__nav">${navPrev}<button type="button" class="bp-cta-pastel bp-modal-docs__nav-next" data-bp-step-next disabled>${h(t('modal_docs_nav_next'))}</button></div>`
      );
    }
    // step 3
    var optionalSectionHtml =
      opts.statusSlug === 'contractualisation'
        ? `<div class="bp-modal-docs__optional-section"><p class="bp-modal-docs__optional-title">${h(t('modal_docs_optional_section_title'))}</p><div class="bp-modal-docs__zones" data-bp-optional-zone-container>${renderZones([{ key: 'marquage_screenshot', required: false }])}</div></div>`
        : '';
    return (
      `<p class="bp-modal__intro">${h(t('modal_docs_step3_intro'))}</p>` +
      `<div class="bp-modal-docs__zones">${renderZones([
        { key: 'cni', required: true },
        { key: 'rib', required: true },
      ])}</div>` +
      optionalSectionHtml +
      `<p class="bp-modal-docs__disclaimer">${h(t('modal_docs_disclaimer'))}</p>` +
      `<div class="bp-modal-docs__nav">${navPrev}<button type="button" class="bp-cta-pastel" data-bp-docs-submit disabled>${h(t('modal_docs_submit'))}</button></div>`
    );
  }

  function openPartDocsModal(opts) {
    var repriseId = opts.repriseId;
    var allDocs = [
      { key: 'contrat_signe', required: true },
      { key: 'cni', required: true },
      { key: 'rib', required: true },
    ];
    if (opts.statusSlug === 'contractualisation') {
      allDocs.push({ key: 'marquage_screenshot', required: false });
    }
    var files = {};
    var currentStep = 1;
    var content = `<div class="bp-modal__container bp-modal-docs bp-modal-docs--stepper"><button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button><h2 class="bp-modal__title">${h(t('modal_docs_title'))}</h2>${buildStepperHtml()}<div class="bp-modal-docs__step-body" data-bp-step-body></div></div>`;

    return window.buybackPortalModals._createDialog({
      className: 'bp-modal--docs',
      content: content,
      ariaLabel: t('modal_docs_title'),
      onMount: function (dlg) {
        var body = dlg.querySelector('[data-bp-step-body]');
        window.buybackPortalModals._bindClose(dlg, '[data-bp-modal-close]');

        var renderStep = function (step) {
          currentStep = step;
          updateStepperUi(dlg, currentStep);
          body.innerHTML = buildStepBody(currentStep, opts);
          if (currentStep === 1) bindContractDownload(body, repriseId);

          var nextBtn = body.querySelector('[data-bp-step-next]');
          var prevBtn = body.querySelector('[data-bp-step-prev]');
          var submitBtn = body.querySelector('[data-bp-docs-submit]');

          var updateState = function () {
            if (currentStep === 2 && nextBtn) nextBtn.disabled = !files['contrat_signe'];
            if (currentStep === 3 && submitBtn) submitBtn.disabled = !(files['cni'] && files['rib']);
          };

          attachZoneListeners(body, files, updateState);
          updateState();

          if (prevBtn)
            prevBtn.addEventListener('click', function () {
              renderStep(currentStep - 1);
            });
          if (nextBtn) {
            nextBtn.addEventListener('click', function () {
              if (currentStep === 2 && !files['contrat_signe']) return;
              renderStep(currentStep + 1);
            });
          }
          if (submitBtn) {
            submitBtn.addEventListener('click', function () {
              uploadAllDocs(dlg, submitBtn, allDocs, files, repriseId, opts);
            });
          }
        };

        renderStep(1);
      },
    });
  }

  // Entry point
  function openDocsUploadModal(opts) {
    opts = opts || {};
    var vendorType = opts.vendorType === 'PRO' ? 'PRO' : 'PART';
    if (vendorType === 'PRO') return openProDocsModal(opts);
    return openPartDocsModal(opts);
  }

  // Export
  window.buybackPortalModalDocs = { open: openDocsUploadModal };
})(window, document);
